import * as actions from 'client/actions/actionsManagement'
import { useSetEntityHighlighted } from 'client/context/HighlightedContext'
import { useManagement, usePage } from 'client/store'
import managementSelectors from 'client/store/management/managementSelectors'
import pageSelectors from 'client/store/page/pageSelectors'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { useActions } from 'common/hooks/useActions'
import { Entities } from 'common/utils/entityUtils'
import { useCallback, useMemo } from 'react'
import { EntityIdType } from 'src/shared/schemas/entity-id.schema'

const omitEntityTypes = (entity: Entities[number]) =>
  [
    EntityTypeEnum.Column,
    EntityTypeEnum.FaqItem,
    EntityTypeEnum.CarouselItem,
  ].includes(entity.type as EntityTypeEnum) === false

export const useBreadcrumbs = () => {
  const editingId = useManagement(managementSelectors.getEditingId)
  const breadcrumbs = usePage(page =>
    pageSelectors.getBreadcrumbs(page, editingId || ''),
  )
  const setHighlightedId = useSetEntityHighlighted()
  const toggleSettingsAction = useActions(actions.toggleSettings)

  const breadcrumbsValues = useMemo(
    () => Object.values(breadcrumbs),
    [breadcrumbs],
  )
  const filteredBreadcrumbs = useMemo(
    () => breadcrumbsValues.filter(omitEntityTypes).reverse(),
    [breadcrumbsValues],
  )

  const handleHighlight = useCallback(
    (id?: EntityIdType) => () => setHighlightedId(id ?? ''),
    [setHighlightedId],
  )
  const handleToggleSettings = useCallback(
    (id: EntityIdType) => () => toggleSettingsAction(id),
    [toggleSettingsAction],
  )

  return {
    filteredBreadcrumbs,
    handleHighlight,
    handleToggleSettings,
  }
}
